import { isValuePresent } from '@/bundles/App/helpers/isValuePresent';
import { getRangeFromToLabel } from '@/bundles/GroupFilters/helpers/formatters/range/getRangeFromToLabel';
import { Nullable } from '@/utils/types';
import { SpaceMeasurementUnits } from '@/bundles/MeasurementUnits/types';
import { formatNumber } from '@/utils/filters';

export const getLandSizeRangeFormattedValue = (value: [Nullable<number>, Nullable<number>], selectedUnit?: SpaceMeasurementUnits): string => {
  const isValuePresentInArray = value.some((v) => isValuePresent(v));

  return isValuePresentInArray ? getRangeFromToLabel(value.map((item) => {
    const formatter = selectedUnit === SpaceMeasurementUnits.acres
      ? (v: Nullable<number>) => v?.toString() ? `${v} ACRES` : null
      : (v: Nullable<number>) => formatNumber(v) ? `${formatNumber(v)} SF` : null;
    return isValuePresent(item) ? formatter(item) : null; // todo: add formatting to sf here, when filter sets will be updated on api side
  })) : '';
}
